!function() {
  class t extends HTMLElement {
    constructor() {
      super(), this.buttons = [], this.summary = null, this.details = null, this.detailsDisclosure = null, 
      this.onKeyDown = this.onKeyDown.bind(this), this.onSummaryKeyDown = this.onSummaryKeyDown.bind(this), 
      this.updateButtons = this.updateButtons.bind(this);
    }
    connectedCallback() {
      this.details = this.closest("details"), this.detailsDisclosure = this.closest("details-disclosure"), 
      this.summary = this.details ? this.details.querySelector("summary") : null, this.updateButtons(), 
      this.addEventListener("keydown", this.onKeyDown), this.summary && this.summary.addEventListener("keydown", this.onSummaryKeyDown), 
      this.observer = new MutationObserver(t => {
        t.some(t => "childList" === t.type) && (this.updateButtons(), this.restoreFocus());
      }), this.observer.observe(this, {
        childList: !0,
        subtree: !0
      });
    }
    disconnectedCallback() {
      this.removeEventListener("keydown", this.onKeyDown), this.summary && this.summary.removeEventListener("keydown", this.onSummaryKeyDown), 
      this.observer && this.observer.disconnect();
    }
    updateButtons() {
      this.buttons = Array.from(this.querySelectorAll("[data-button]")), this.buttons.length && this.initAccessibility();
    }
    restoreFocus() {
      this.details.hasAttribute("open") && document.activeElement === document.body && this.focusItem(0);
    }
    initAccessibility() {
      this.buttons.forEach((t, e) => {
        0 === e ? t.setAttribute("tabindex", "0") : t.setAttribute("tabindex", "-1");
      });
    }
    onSummaryKeyDown(t) {
      "ArrowDown" === t.key && this.details.hasAttribute("open") && (t.preventDefault(), 
      this.buttons.length > 0 && this.focusItem(0));
    }
    onKeyDown(t) {
      if (0 === this.buttons.length) return;
      const e = this.buttons.indexOf(document.activeElement);
      if (-1 !== e) switch (t.key) {
       case "Escape":
        t.preventDefault(), this.closeMenu();
        break;

       case "ArrowDown":
        t.preventDefault(), this.focusNextItem(e);
        break;

       case "ArrowUp":
        t.preventDefault(), this.focusPrevItem(e);
        break;

       case "Home":
        t.preventDefault(), this.focusItem(0);
        break;

       case "End":
        t.preventDefault(), this.focusItem(this.buttons.length - 1);
        break;

       case "Enter":
       case " ":
        t.preventDefault(), this.buttons[e].click();
      }
    }
    closeMenu() {
      this.details && this.details.hasAttribute("open") && (this.detailsDisclosure ? this.detailsDisclosure.close() : this.details.removeAttribute("open"), 
      this.summary && (this.summary.focus(), this.detailsDisclosure || this.summary.setAttribute("aria-expanded", "false")));
    }
    focusNextItem(t) {
      const e = t + 1 < this.buttons.length ? t + 1 : 0;
      this.focusItem(e);
    }
    focusPrevItem(t) {
      const e = t - 1 >= 0 ? t - 1 : this.buttons.length - 1;
      this.focusItem(e);
    }
    focusItem(t) {
      const e = this.buttons[t];
      e && (this.buttons.forEach(t => t.setAttribute("tabindex", "-1")), e.setAttribute("tabindex", "0"), 
      e.focus(), e.scrollIntoView({
        block: "nearest"
      }));
    }
  }
  customElements.get("filter-menu") || customElements.define("filter-menu", t);
}();